<template>
    <div class="hello">
        <button @click="open">弹窗</button>
        <div style="height: 100vh" @click="smsVisible=false"/>
        <smsCode v-model="smsVisible" biztype="03" v-on:hide-sms="smsVisible=false"></smsCode>
    </div>
</template>

<script>
import smsCode from "./SMS/smsCode";
export default {
    name: 'HelloWorld',
    components: {
        smsCode
    },
    props: {
        msg: String
    },
    data() {
        return {
            smsVisible: false
        };
    },
    methods: {
        open() {
            this.smsVisible = true;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.hello {
    width: 100%;
}
</style>
